import { Link } from 'react-router-dom';
export default function Brand() { return <Link to="/" className="nc-brand" aria-label="NephroCore Nexus home"><img src="/nephrocore-depth.svg" alt="" width="36" height="50" /><span>NephroCore<small>NEXUS</small></span></Link>; }
